// removed by extract-text-webpack-plugin
module.exports = {"socialLogin":"SocialLoginButtons__socialLogin","growDotQello":"SocialLoginButtons__growDotQello","growDotBlue":"SocialLoginButtons__growDotBlue","growDotGolden":"SocialLoginButtons__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SocialLoginButtons/SocialLoginButtons.scss
// module id = 1884
// module chunks = 0